import React from "react";
import { connect } from "react-redux";

import "./EditSettings.css"

import history from "../../../../../history";
import { getOuName, getOuSettings, editOuSettings } from "../../../../../actions/structureActions";


class EditSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            parentMode: null,
            currentMode: null
        };
    }

    componentDidMount() {
        this.props.getOuName(this.props.match.params.ouID);
        this.props.getOuSettings(this.props.match.params.ouID, this.onValuesLoad);
    }

    onValuesLoad = () => this.setState({
        parentMode: this.props.parentAcceptMode,
        currentMode: this.props.currentAcceptMode
    });

    onValueChange = property => event => this.setState({ [property]: +event.target.value });

    onChangesApply = () => {
        if (this.state.parentMode !== this.props.parentAcceptMode || this.state.currentMode !== this.props.currentAcceptMode) this.props.editOuSettings(this.props.match.params.ouID, this.state, () => history.push(`/structure/unit/${this.props.match.params.ouID}`));
        else history.push(`/structure/unit/${this.props.match.params.ouID}`);
    };

    render() {
        return (
            <React.Fragment>
                <div className="edit-settings-component ui container">
                    <div className="ui container">
                        <div className="ui header">
                            <div className="content">Ustawienia jednostki: {this.props.ouName}</div>
                        </div>
                        <div className="ui divider" />
                        <div className="ui segment">
                            <div className="ui small header">Wymagaj potwierdzenia w jednostce nadrzędnej:</div>
                            <label><input type="radio" name="parentMode" value="0"
                                checked={this.state.parentMode === 0} onChange={this.onValueChange("parentMode")}
                            />&ensp;wszystkich wniosków (domyślnie)</label><br />
                            <label><input type="radio" name="parentMode" value="1"
                                checked={this.state.parentMode === 1} onChange={this.onValueChange("parentMode")}
                            />&ensp;tylko wniosków przełożonych</label><br />
                            <label><input type="radio" name="parentMode" value="2"
                                checked={this.state.parentMode === 2} onChange={this.onValueChange("parentMode")}
                            />&ensp;żadnych wniosków</label>
                        </div>
                        <div className="ui segment">
                            <div className="ui small header">W przypadku braku przełożonego:</div>
                            <label><input type="radio" name="currentMode" value="0"
                                checked={this.state.currentMode === 0} onChange={this.onValueChange("currentMode")}
                            />&ensp;wymagaj potwierdzenia mimo to (domyślnie)</label><br />
                            <label><input type="radio" name="currentMode" value="1"
                                checked={this.state.currentMode === 1} onChange={this.onValueChange("currentMode")}
                            />&ensp;nie wymagaj potwierdzenia</label><br />
                        </div>
                        <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    ouName: state.structure.edit.name,
    parentAcceptMode: state.structure.edit.parentAcceptMode,
    currentAcceptMode: state.structure.edit.currentAcceptMode
});

export default connect(mapStateToProps, { getOuName, getOuSettings, editOuSettings })(EditSettings);